import styled from 'styled-components';

export default styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: ${(9 / 16) * 100}%;
  overflow: hidden;

  > * {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
  }
`;
